import {
  SOCIAL_STREAMS,
  SOCIAL_STREAM_TABS,
  SocialStream,
  SocialStreamTab,
} from '@/types/socialMediaPost';

const socialStreamSet: Set<string> = new Set(SOCIAL_STREAMS);
const socialStreamTabSet: Set<string> = new Set(SOCIAL_STREAM_TABS);

/**
 * Validates if a string is a valid social stream
 */
export function isValidSocialStream(
  value: string | null | undefined
): value is SocialStream {
  return value != null && socialStreamSet.has(value);
}

/**
 * Validates if a string is a valid social stream tab (includes 'all')
 */
export function isValidSocialStreamTab(
  value: string | null | undefined
): value is SocialStreamTab {
  return value != null && socialStreamTabSet.has(value);
}
